import { WidgetWrapper } from '@agentselly/ui';
import { useTranslate } from '@tolgee/react';

export function PartnerContentWidget() {
  const { t } = useTranslate();

  return (
    <WidgetWrapper title={t('partner_content_title')}>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {[
          {
            url: 'https://www.valiant.ch/de/blog/im-fokus-wachsen',
            image: '/assets/demo/partner-content-post-1.webp',
            category: 'Finanzen',
            title: 'Im Fokus: Wachsen',
            description:
              '«Wachstum ist immer eine Herausforderung», schreibt Ewald Burgener im Editorial zur neuen ValOr-Ausgabe.',
          },
          {
            url: 'https://www.valiant.ch/de/blog/wohnen-mit-see-und-bergsicht',
            image: '/assets/demo/partner-content-post-2.webp',
            category: 'Wohnen',
            title: 'Wohnen mit See- und Bergsicht',
            description:
              'Florence und Alexandre Blanc haben ihren Traum vom eigenen Haus am Genfersee wahrgemacht.',
          },
          {
            url: 'https://www.valiant.ch/de/blog/innovativ-bauen-nachhaltig-finanzieren',
            image: '/assets/demo/partner-content-post-3.webp',
            category: 'Wohnen & Nachhaltigkeit',
            title: 'Innovativ bauen – nachhaltig finanzieren',
            description:
              'Valiant finanziert auch spezielle Immobilienprojekte: zum Beispiel das Zweifamilienhaus von Irene und Mario Renold, dessen meterdicke Aussenwände mit Strohballen gefüllt sind. Im Spätsommer ist das Paar eingezogen – und fühlt sich darin pudelwohl.',
          },
        ].map((post) => (
          <a
            key={post.url}
            className="flex flex-col flex-grow gap-2 rounded-xl overflow-hidden hover:opacity-50 border border-gray-100 dark:border-gray-700 pb-4"
            href={post.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={post.image}
              alt={post.url}
              className="block w-full object-cover aspect-16/9"
            />
            <span className="px-4 text-xs text-primary-400">
              {post.category}
            </span>
            <span className="px-4 text-lg">{post.title}</span>
            <span className="px-4 text-xs h-full max-h-[80px] truncate">
              {post.description}
            </span>
            <span className="px-4 text-primary-400">Artikel lesen →</span>
          </a>
        ))}
      </div>
    </WidgetWrapper>
  );
}
